const errorMessages = {
    'validation.bad_word': 'Your message includes a restricted word. Please revise it.',
}

export default errorMessages